export default __webpack_public_path__ + "static/media/NH005.43739e97.jpg";